/* eslint-disable max-len */
import React from 'react';

const DocumentIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" {...props}>
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M11 0H2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5l-5-5zM2 19a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8v5h5v12a1 1 0 0 1-1 1H2zm9-14V1.42L14.58 5H11z"
    />
  </svg>
);

export default DocumentIcon;
